import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { AVIS_VERIFIES_URL_REVIEWS } from '~/constants';
import useMobileObserver from '~/composables/useMobileObserver';
import { unescape } from 'lodash-es';
import { isAuthorizedLanguage } from '~/i18n.config';
var _useMobileObserver = useMobileObserver(),
  isMobile = _useMobileObserver.isMobile;
var mfbIframeBlock = 'mfbIframeBlock';
export var avisVerifiesTokens = getAvisVerifiesTokens();
function getAvisVerifiesTokens() {
  var tokens = {
    fr: process.env.AVIS_VERIFIES_TOKEN_FR,
    it: process.env.AVIS_VERIFIES_TOKEN_IT
  };
  if (process.env.NODE_ENV === 'development' && process.env.AVIS_VERIFIES_TOKEN_DEV) {
    tokens.dev = process.env.AVIS_VERIFIES_TOKEN_DEV;
  }
  if (isAuthorizedLanguage('en') && process.env.AVIS_VERIFIES_TOKEN_EN) {
    tokens.en = process.env.AVIS_VERIFIES_TOKEN_EN;
  }
  if (isAuthorizedLanguage('de') && process.env.AVIS_VERIFIES_TOKEN_DE) {
    tokens.de = process.env.AVIS_VERIFIES_TOKEN_DE;
  }
  if (isAuthorizedLanguage('es') && process.env.AVIS_VERIFIES_TOKEN_ES) {
    tokens.es = process.env.AVIS_VERIFIES_TOKEN_ES;
  }
  return tokens;
}
function transformReviews(reviewsData, locale) {
  var transformedReviews = [];
  for (var i = 0; i < (reviewsData === null || reviewsData === void 0 ? void 0 : reviewsData.length); i++) {
    var _review$translated_re;
    var review = reviewsData[i];
    var localReview = locale === 'fr' ? review.review : ((_review$translated_re = review.translated_review) === null || _review$translated_re === void 0 ? void 0 : _review$translated_re[locale]) || review.review;
    var transformedReview = {
      rating: review.rate,
      description: unescape(localReview),
      firstName: review.firstname,
      lastName: review.lastname,
      date: review.review_date,
      customerServiceResponse: review.moderations
    };
    transformedReviews.push(transformedReview);
  }
  return transformedReviews;
}

/**
 * Fetch product reviews from Skeepers API.
 *
 * @param {string} country - The country code (DE, EN, ES, IT, FR).
 * @param {string[]} refs - Array of product references (SKUs).
 * @param {number} limit - Number of reviews to fetch.
 * @returns {Promise<Reviews[]>} - The API response.
 */
function fetchReviews(_x, _x2, _x3) {
  return _fetchReviews.apply(this, arguments);
}
/**
 * Fetches average review data for a specific product ID (and optional locale).
 *
 * @param      {string[]}  id      The product IDs
 * @param      {string}    locale  The locale (optional)
 * @return     {Promise<Reviews[]>}  The average reviews.
 */
function _fetchReviews() {
  _fetchReviews = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(country, refs, limit) {
    var _avisVerifiesTokens$c;
    var websiteId, refQuery, apiUrl, _reviews$data, _reviewsData$, reviews, reviewsData, transformedReviews;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          websiteId = (_avisVerifiesTokens$c = avisVerifiesTokens[country]) !== null && _avisVerifiesTokens$c !== void 0 ? _avisVerifiesTokens$c : '';
          if (websiteId) {
            _context2.next = 4;
            break;
          }
          console.warn("No websiteId found for country: ".concat(country));
          return _context2.abrupt("return", []);
        case 4:
          refQuery = refs.length > 0 ? refs.join(',') : '';
          apiUrl = "".concat(process.env.AVIS_VERIFIES_API_URL, "/").concat(websiteId, "/products/reviews?ref=").concat(refQuery, "&limit=").concat(limit);
          _context2.prev = 6;
          _context2.next = 9;
          return $fetch(apiUrl, {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          });
        case 9:
          reviews = _context2.sent;
          reviewsData = Object.values((_reviews$data = reviews.data) !== null && _reviews$data !== void 0 ? _reviews$data : []);
          transformedReviews = transformReviews((_reviewsData$ = reviewsData[0]) !== null && _reviewsData$ !== void 0 ? _reviewsData$ : [], country);
          return _context2.abrupt("return", transformedReviews);
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](6);
          console.error('Error fetching product reviews:', _context2.t0);
          return _context2.abrupt("return", []);
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[6, 15]]);
  }));
  return _fetchReviews.apply(this, arguments);
}
function fetchAverageReviews(_x4, _x5) {
  return _fetchAverageReviews.apply(this, arguments);
}
function _fetchAverageReviews() {
  _fetchAverageReviews = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, locale) {
    var body, _avisVerifiesTokens$l;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          body = JSON.stringify({
            idWebsite: (_avisVerifiesTokens$l = avisVerifiesTokens[locale]) !== null && _avisVerifiesTokens$l !== void 0 ? _avisVerifiesTokens$l : '',
            query: 'average',
            products: id,
            plateforme: locale !== null && locale !== void 0 ? locale : ''
          });
          _context3.next = 8;
          break;
        case 4:
          _context3.prev = 4;
          _context3.t0 = _context3["catch"](0);
          console.warn('[useReviews] - JSON.stringify failed:', _context3.t0);
          return _context3.abrupt("return", []);
        case 8:
          _context3.prev = 8;
          _context3.next = 11;
          return $fetch(AVIS_VERIFIES_URL_REVIEWS, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: body,
            redirect: 'follow'
          });
        case 11:
          return _context3.abrupt("return", _context3.sent);
        case 14:
          _context3.prev = 14;
          _context3.t1 = _context3["catch"](8);
          console.warn('[useReviews] - Could not fetch average reviews:', _context3.t1);
          return _context3.abrupt("return", []);
        case 18:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 4], [8, 14]]);
  }));
  return _fetchAverageReviews.apply(this, arguments);
}
var tokensForAllReviews = Object.entries(avisVerifiesTokens).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    locale = _ref2[0],
    token = _ref2[1];
  return _defineProperty({}, locale, token);
});
function fetchAllAverageReviews(_x6) {
  return _fetchAllAverageReviews.apply(this, arguments);
}
/** TODO Doesn't these spreads operators copy twice the recipe objects ?
 * one from ...object and one from ...objet.fields
 * **/
function _fetchAllAverageReviews() {
  _fetchAllAverageReviews = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
    var results, responses, _iterator, _step, response, responseId, item, _id, _item;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          results = {};
          _context4.prev = 1;
          _context4.next = 4;
          return Promise.all(tokensForAllReviews.map(function (token) {
            return fetchAverageReviews(id, Object.keys(token)[0]);
          }));
        case 4:
          responses = _context4.sent;
          _iterator = _createForOfIteratorHelper(responses);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              response = _step.value;
              for (responseId in response) {
                if (response.hasOwnProperty(responseId)) {
                  if (!results[responseId]) {
                    results[responseId] = {
                      count: 0,
                      totalRate: 0
                    };
                  }
                  item = response[responseId][0];
                  results[responseId].count += Number(item.count);
                  results[responseId].totalRate += Number(item.rate) * Number(item.count); // Multiply rate by count to get total
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          _context4.next = 11;
          break;
        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](1);
        case 11:
          for (_id in results) {
            _item = results[_id];
            _item.averageRate = _item.count ? _item.totalRate / _item.count : 0;
            delete _item.totalRate;
          }
          return _context4.abrupt("return", results);
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 9]]);
  }));
  return _fetchAllAverageReviews.apply(this, arguments);
}
function mergingDatas(recipes, reviews) {
  var recipesReviews = recipes.map(function (obj) {
    var _obj$sys;
    var id = (_obj$sys = obj.sys) === null || _obj$sys === void 0 ? void 0 : _obj$sys.id;
    if (reviews && Object.prototype.hasOwnProperty.call(reviews, id) && id) {
      var review = reviews[id];
      return _objectSpread(_objectSpread({}, obj), {}, {
        fields: _objectSpread(_objectSpread(_objectSpread({}, obj.fields), review), {}, {
          reviewsRating: {
            rate: review.averageRate,
            count: review.count
          }
        })
      });
    } else {
      return _objectSpread({}, obj);
    }
  });
  return recipesReviews;
}
function mergingRecipeFromGraphqlCTFAndReviews(recipes, reviews) {
  return recipes.map(function (obj) {
    var _obj$id;
    var id = (_obj$id = obj.id) !== null && _obj$id !== void 0 ? _obj$id : null;
    if (id && reviews && Object.prototype.hasOwnProperty.call(reviews, id) && id) {
      var review = reviews[id];
      return _objectSpread(_objectSpread({}, obj), {}, {
        reviewsRating: {
          rate: review.averageRate,
          count: review.count
        }
      });
    } else {
      return _objectSpread({}, obj);
    }
  });
}
function recoverId(array) {
  if (array) {
    return array.map(function (objet) {
      var _objet$sys$id, _objet$sys;
      return (_objet$sys$id = objet === null || objet === void 0 ? void 0 : (_objet$sys = objet.sys) === null || _objet$sys === void 0 ? void 0 : _objet$sys.id) !== null && _objet$sys$id !== void 0 ? _objet$sys$id : objet === null || objet === void 0 ? void 0 : objet.id;
    });
  }
}
var scrollToReviews = function scrollToReviews(hash) {
  if (!hash) return;
  var isMobilePosition = 235;
  var isNormalPosition = 10;
  var isTablet = 821;
  var topPosition = window.innerWidth < isTablet ? isMobilePosition : isNormalPosition;
  var anchor = document.querySelector("".concat(hash));
  if (!anchor) return;
  var y = anchor.getBoundingClientRect().top + window.scrollY;
  window.scroll({
    top: y - topPosition,
    behavior: 'smooth'
  });
};
var isScriptLoaded = ref(false);
var loadScript = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(event, eventCurrentTarget) {
    var script;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof window !== 'undefined')) {
            _context.next = 13;
            break;
          }
          if (!document.getElementById('MFBIframeManager')) {
            _context.next = 4;
            break;
          }
          isScriptLoaded.value = true;
          return _context.abrupt("return");
        case 4:
          script = document.createElement('script');
          script.id = 'MFBIframeManager';
          script.src = 'https://cdnroom.myfeelback.com/lib/frontend/iframe-manager/im.min.js';
          script.type = 'text/javascript';
          script.onload = function () {
            isScriptLoaded.value = true;
            openModal(event, eventCurrentTarget);
          };
          script.onerror = function () {
            console.error("Le script n'a pas pu être chargé");
          };
          document.head.appendChild(script);
          _context.next = 14;
          break;
        case 13:
          console.error('Cette fonction ne peut être appelée que du côté client');
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadScript(_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();
var openModal = function openModal(event, eventCurrentTarget) {
  if (isScriptLoaded.value) {
    try {
      window.MFBIframe.open(eventCurrentTarget, event);
      event.preventDefault();
      if (isMobile.value) {
        document.getElementById(mfbIframeBlock).style.width = '100%';
        document.getElementById(mfbIframeBlock).style.height = '100%';
      } else {
        document.getElementById(mfbIframeBlock).style.width = '588px';
        document.getElementById(mfbIframeBlock).style.height = '552px';
      }
    } catch (error) {
      console.error("Une erreur est survenue lors de l'ouverture de la modale", error);
    }
  }
};
function findReviewDate(customFieldsRaw) {
  if (!customFieldsRaw) {
    return null;
  }
  var reviewDateField = customFieldsRaw.find(function (field) {
    return field.name === 'review-date';
  });
  return reviewDateField ? reviewDateField.value : null;
}
function findReviewModeration(customFieldsRaw) {
  var _moderationField$refe;
  if (!customFieldsRaw) {
    return null;
  }
  var moderationField = customFieldsRaw.find(function (field) {
    return field.name === 'moderation';
  });
  return moderationField === null || moderationField === void 0 ? void 0 : (_moderationField$refe = moderationField.referencedResource) === null || _moderationField$refe === void 0 ? void 0 : _moderationField$refe.value;
}
function transformReviewsProduct(reviewsData) {
  return reviewsData.map(function (review) {
    var _review$custom, _review$custom2;
    return {
      rating: review.rating,
      description: unescape(review.text),
      name: review.authorName,
      date: findReviewDate(review === null || review === void 0 ? void 0 : (_review$custom = review.custom) === null || _review$custom === void 0 ? void 0 : _review$custom.customFieldsRaw) || review.createdAt,
      customerServiceResponse: findReviewModeration(review === null || review === void 0 ? void 0 : (_review$custom2 = review.custom) === null || _review$custom2 === void 0 ? void 0 : _review$custom2.customFieldsRaw)
    };
  });
}
export { transformReviewsProduct, isScriptLoaded, loadScript, openModal, scrollToReviews, fetchReviews, fetchAverageReviews, mergingDatas, mergingRecipeFromGraphqlCTFAndReviews, recoverId, fetchAllAverageReviews };